import { render, staticRenderFns } from "./unknownErrorView.vue?vue&type=template&id=0982083a&"
import script from "./unknownErrorView.vue?vue&type=script&lang=js&"
export * from "./unknownErrorView.vue?vue&type=script&lang=js&"
import style0 from "./unknownErrorView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports